import { render, staticRenderFns } from "./ProductIntroductionTemplateSelect.vue?vue&type=template&id=55dc9712&scoped=true"
import script from "./ProductIntroductionTemplateSelect.vue?vue&type=script&lang=js"
export * from "./ProductIntroductionTemplateSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55dc9712",
  null
  
)

export default component.exports